import { useQueryClient } from "@tanstack/react-query";
import { GuidelineManager, type GuidelineActions } from "@studio-features/meta-crew/manuscript-guidelines";
import { api, errorMessage } from "../lib/api";
import { can } from "../lib/access";
import { refineKeys, useGuidelines } from "../lib/refine-api";
import type { Me } from "../lib/types";
import { PanelError } from "../console/ui";

/**
 * 시스템 설정 › 원고 가이드라인 (요청서 29-4절, 시안 388082b GuidelineManager). docs/meta-crew-manuscript-refine-design.md 3절.
 * 본문은 고치지 않고 새 버전(비활성)을 올린 뒤 활성으로 바꾼다. 보기 MANUSCRIPT_READ, 관리 MANUSCRIPT_GUIDELINE (서버도 같은 코드로 막는다).
 */
export function GuidelinesScreen({ me }: { me: Me }) {
  const qc = useQueryClient();
  const g = useGuidelines(can(me, "MANUSCRIPT_READ"));
  if (!can(me, "MANUSCRIPT_READ")) return <PanelError error="권한이 없습니다." />;
  const reload = () => void qc.invalidateQueries({ queryKey: refineKeys.guidelines });
  const actions: GuidelineActions = {
    create: async (input) => {
      try {
        await api.post("/admin/manuscript-guidelines", { kind: input.kind, label: input.label, body: input.body, note: input.note || undefined });
      } catch (e) {
        throw new Error(errorMessage(e));
      } finally {
        reload();
      }
    },
    activate: async (id) => {
      try {
        await api.post(`/admin/manuscript-guidelines/${id}/activate`);
      } catch (e) {
        throw new Error(errorMessage(e));
      } finally {
        reload();
      }
    },
    reload,
  };
  return <GuidelineManager versions={g.versions} actions={actions} canManage={can(me, "MANUSCRIPT_GUIDELINE")} loading={g.loading} error={g.error ? errorMessage(g.error) : undefined} />;
}
